import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/home.vue'

const routes = [
  {
    path: '/',
    name: 'homeIndex',
    component: Home,
    redirect: {
      name: 'wodeIndex'
    },
    children: [ 
      // 我的
      {
        path: 'wode-index',
        component: () => import('@/views/wode/index.vue'),
        name: 'wodeIndex',
        meta: {}
      },
      // 消息
      {
        path: 'xiaoxi-index',
        component: () => import('@/views/xiaoxi/index.vue'),
        name: 'xiaoxiIndex',
        meta: {}
      },
      // 游戏
      {
        path: 'youxi-index',
        component: () => import('@/views/youxi/index.vue'),
        name: 'youxiIndex',
        meta: {}
      },
      // 福利
      {
        path: 'fuli-index',
        component: () => import('@/views/fuli/index.vue'),
        name: 'fuliIndex',
        meta: {}
      },
      // 返利
      {
        path: 'fanli-index',
        component: () => import('@/views/fanli/index.vue'),
        name: 'fanliIndex',
        meta: {}
      },
    ]
  },
  // 钱包
  {
    path: '/wallet-index',
    name: 'walletIndex',
    component: () => import('@/views/wallet/index.vue')
  },
  // 钱包记录
  {
    path: '/wallet-record',
    name: 'walletRecord',
    component: () => import('@/views/wallet/record.vue')
  },
  // 小号管理
  {
    path: '/account-index',
    name: 'accountIndex',
    component: () => import('@/views/account/index.vue')
  },
  // 设置
  {
    path: '/setting-index',
    name: 'settingIndex',
    component: () => import('@/views/setting/index.vue')
  },
  // 实名认证
  {
    path: '/real-name',
    name: 'realName',
    component: () => import('@/views/setting/realName.vue')
  },
  // 修改密码
  {
    path: '/password-index',
    name: 'passwordIndex',
    component: () => import('@/views/setting/password.vue')
  },
  // 用户协议
  {
    path: '/agreement-index',
    name: 'agreementIndex',
    component: () => import('@/views/setting/agreement.vue')
  },
  // 手机绑定
  {
    path: '/mobile-phone',
    name: 'mobilePhone',
    component: () => import('@/views/setting/mobilePhone.vue')
  },
  // 消息详情
  {
    path: '/xiaoxi-details',
    name: 'xiaoxiDetails',
    component: () => import('@/views/xiaoxi/details.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
